// 账户与身份：简体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 公共基础词条
export const base = Object.freeze({
  "account.quickEntry": "快捷入口",
  "account.featuredTrade": "精选交易",
  "account.userOverview": "用户与资产概览",
  "account.assetsOverview": "资产概览",
  "account.defaultReviewLevel": "好评等级1",
  "account.avatar": "用户头像",
  "account.applyBroker": "申请谈判人",
  "account.loggedIn": "已登录",
  "account.balance": "账户余额",
  "account.withdraw": "去提现",
  "account.withdrawable": "可提现",
  "account.frozen": "冻结中",
  "account.points": "积分",
  "account.coins": "金币",
  "account.tradeOrders": "交易订单",
  "account.goodsCenter": "商品中心",
  "account.messages": "消息管理",
  "account.goodsLibrary": "商品库",
  "account.suppliers": "供应商管理",
  "account.logoutCurrent": "退出当前账号",
  "account.comingSoon": "即将开放",
});

// 账户设置
export const settings = Object.freeze({
  "accountSettings.save": "保存",
  "accountSettings.reset": "重置",
  "accountSettings.security.title": "安全设置",
  "accountSettings.security.oldPassword": "原密码",
  "accountSettings.security.enterOldPassword": "请输入原密码",
  "accountSettings.security.newPassword": "新密码",
  "accountSettings.security.enterNewPassword": "请输入新密码",
  "accountSettings.security.confirmPassword": "确认密码",
  "accountSettings.security.enterConfirmPassword": "请再次输入新密码",
  "accountSettings.security.mobileVerification": "手机验证",
  "accountSettings.security.enterCode": "请输入验证码",
  "accountSettings.security.resendAfter": "{seconds}秒后重发",
  "accountSettings.security.getCode": "获取验证码",
  "accountSettings.security.tipsTitle": "安全提示",
  "accountSettings.security.tipLength": "密码长度至少8位，包含字母和数字",
  "accountSettings.security.tipComplexity": "不要使用过于简单的密码",
  "accountSettings.security.tipRotation": "定期更换密码，保障账号安全",
  "accountSettings.security.tipPublic": "不要在公共场合输入密码",
  "accountSettings.security.passwordMismatch": "两次输入的密码不一致",
  "accountSettings.security.minLength": "密码长度至少8位",
  "accountSettings.security.codeSent": "验证码已发送",
  "accountSettings.security.passwordChanged": "密码修改成功",
  "accountSettings.personal.title": "个人资料",
  "accountSettings.personal.avatar": "头像",
  "accountSettings.personal.nickname": "昵称",
  "accountSettings.personal.enterNickname": "请输入昵称",
  "accountSettings.personal.mobile": "手机号",
  "accountSettings.personal.enterMobile": "请输入手机号",
  "accountSettings.personal.invalidMobile": "请输入正确的手机号",
  "accountSettings.personal.email": "邮箱",
  "accountSettings.personal.enterEmail": "请输入邮箱",
  "accountSettings.personal.gender": "性别",
  "accountSettings.personal.male": "男",
  "accountSettings.personal.female": "女",
  "accountSettings.personal.unspecified": "保密",
  "accountSettings.personal.birthday": "生日",
  "accountSettings.personal.selectDate": "选择日期",
  "accountSettings.personal.address": "地址",
  "accountSettings.personal.enterAddress": "请输入地址",
  "accountSettings.personal.avatarFormat": "上传头像图片只能是 JPG/PNG 格式!",
  "accountSettings.personal.avatarSize": "上传头像图片大小不能超过 2MB!",
  "accountSettings.personal.avatarUploaded": "头像上传成功",
  "accountSettings.personal.saved": "保存成功",
  "accountSettings.verification.title": "账号认证",
  "accountSettings.verification.realNameTitle": "实名认证",
  "accountSettings.verification.verified": "已认证",
  "accountSettings.verification.unverified": "未认证",
  "accountSettings.verification.realName": "真实姓名",
  "accountSettings.verification.enterRealName": "请输入真实姓名",
  "accountSettings.verification.idCard": "身份证号",
  "accountSettings.verification.enterIdCard": "请输入身份证号",
  "accountSettings.verification.invalidIdCard": "请输入正确的身份证号",
  "accountSettings.verification.idCardFront": "身份证正面",
  "accountSettings.verification.uploadIdCardFront": "上传身份证正面",
  "accountSettings.verification.idCardBack": "身份证反面",
  "accountSettings.verification.uploadIdCardBack": "上传身份证反面",
  "accountSettings.verification.submit": "提交认证",
  "accountSettings.verification.companyTitle": "企业认证",
  "accountSettings.verification.companyName": "企业名称",
  "accountSettings.verification.enterCompanyName": "请输入企业名称",
  "accountSettings.verification.businessLicense": "营业执照",
  "accountSettings.verification.uploadBusinessLicense": "上传营业执照",
  "accountSettings.verification.loading": "认证状态加载中...",
  "accountSettings.verification.realNameSubmitted": "实名认证提交成功",
  "accountSettings.verification.companySubmitted": "企业认证提交成功",
});

// 登录注册
export const auth = Object.freeze({
  "auth.supportedSmsRegions":
    "短信目前支持中国大陆和中国香港，其他地区请使用邮箱登录",
  "auth.invalidHongKongMobile": "请输入正确的中国香港手机号（8位数字）",

  "auth.codeLoginMethods": "验证码登录方式",
  "auth.emailLogin": "邮箱登录",
  "auth.emailCodeLogin": "邮箱验证码登录",
  "auth.codeLogin": "验证码登录",
  "auth.switchCodeLogin": "切换到验证码登录",
  "auth.returnCodeLogin": "返回验证码登录",
  "auth.emailAddress": "邮箱",
  "auth.enterEmailAddress": "请输入邮箱",
  "auth.emailCode": "邮箱验证码",
  "auth.defaultMobileVerification": "默认手机号验证",
  "auth.defaultEmailVerification": "默认邮箱验证",
  "auth.mainlandSmsUseEmail":
    "当前短信通道仅支持中国大陆手机号，请使用邮箱登录",
  "auth.verificationCodeSendFailed": "验证码发送失败",
  "auth.emailVerificationCodeSendFailed": "邮箱验证码发送失败",
  "auth.emailVerificationCodeSent": "邮箱验证码已发送",
  "auth.codeLoginPasswordResetHint":
    "请先使用验证码登录，登录后在个人中心修改密码",
  "auth.emailCodeSendFailed": "邮箱验证码发送失败，请稍后重试",
  "auth.emailCodeSent": "邮箱验证码发送成功",
  "auth.brandScene": "Xsou 供应链场景",
  "auth.brandHeadlineFirst": "让每一次供需连接",
  "auth.brandHeadlineSecond": "更快、更准、更可靠",
  "auth.brandService": "卓越服务",
  "auth.brandCreation": "持续创造",
  "auth.brandCollaboration": "协作共赢",
  "auth.brandValue": "价值共享",
  "auth.close": "关闭",
  "auth.accountActions": "账号操作",
  "auth.accountType": "账号类型",
  "auth.login": "登录",
  "auth.register": "注册",
  "auth.mobile": "手机号",
  "auth.mobileOrEmail": "手机号 / 邮箱",
  "auth.areaCode": "国家或地区区号",
  "auth.registerAreaCode": "注册手机号国家或地区区号",
  "auth.areaMainland": "中国大陆 +86",
  "auth.areaHongKong": "中国香港 +852",
  "auth.areaMacau": "中国澳门 +853",
  "auth.areaTaiwan": "中国台湾 +886",
  "auth.areaNorthAmerica": "美国/加拿大 +1",
  "auth.areaSingapore": "新加坡 +65",
  "auth.enterMobile": "请输入手机号",
  "auth.smsCode": "短信验证码",
  "auth.enterCode": "请输入验证码",
  "auth.resendAfter": "{seconds}s 后重发",
  "auth.getCode": "获取验证码",
  "auth.loggingIn": "登录中…",
  "auth.noAccount": "还没有账号？",
  "auth.registerNow": "立即注册",
  "auth.passwordLogin": "密码登录",
  "auth.switchPasswordLogin": "切换到密码登录",
  "auth.wechatLogin": "微信登录",
  "auth.switchWechatLogin": "切换到微信登录",
  "auth.password": "密码",
  "auth.forgotPassword": "忘记密码",
  "auth.enterMobileOrEmail": "请输入手机号或邮箱",
  "auth.enterLoginPassword": "请输入登录密码",
  "auth.hidePassword": "隐藏密码",
  "auth.showPassword": "显示密码",
  "auth.smsLogin": "短信登录",
  "auth.switchSmsLogin": "切换到短信登录",
  "auth.wechatLoginQr": "微信登录二维码",
  "auth.wechatRegisterQr": "微信注册二维码",
  "auth.qrLoading": "二维码加载中",
  "auth.qrExpired": "二维码已失效",
  "auth.refreshQr": "点击刷新",
  "auth.scanWechatToLogin": "使用微信扫码登录",
  "auth.scanWechatLoginHint": "打开微信扫一扫，确认后即可登录",
  "auth.returnSmsLogin": "返回短信验证码登录",
  "auth.personalAccount": "个人账号",
  "auth.companyAccount": "企业账号",
  "auth.mainland": "中国大陆",
  "auth.overseas": "港澳台及海外",
  "auth.defaultMobileRegistration": "默认手机号注册",
  "auth.verifyByMobile": "使用手机号验证",
  "auth.defaultEmailRegistration": "默认邮箱注册",
  "auth.verifyByEmail": "使用邮箱验证",
  "auth.scanWechatToRegister": "使用微信扫码注册",
  "auth.scanWechatRegisterHint": "打开微信扫一扫，确认后即可完成注册并登录",
  "auth.returnMobileRegistration": "返回手机号注册",
  "auth.returnEmailRegistration": "返回邮箱注册",
  "auth.mainlandMobile": "中国大陆手机号",
  "auth.overseasMobile": "港澳台及海外手机号",
  "auth.email": "常用邮箱",
  "auth.enterEmail": "请输入常用邮箱",
  "auth.code": "验证码",
  "auth.enterFourDigitCode": "请输入4位验证码",
  "auth.loginPassword": "登录密码",
  "auth.enterPasswordLength": "请输入 8–20 位密码",
  "auth.companyName": "企业名称",
  "auth.enterCompanyName": "请输入企业全称",
  "auth.contactName": "联系人姓名",
  "auth.enterContactName": "请输入联系人姓名",
  "auth.registering": "注册中…",
  "auth.finishRegistration": "完成注册",
  "auth.haveAccount": "已有账号？",
  "auth.loginNow": "立即登录",
  "auth.wechatRegistration": "微信注册",
  "auth.registrationSuccess": "注册成功",
  "auth.companyAccountCreated": "企业账号已创建",
  "auth.personalAccountCreated": "个人账号已创建",
  "auth.registrationCompleted": "{context}注册已完成。",
  "auth.sentenceSeparator": "",
  "auth.companyCertificationHint": "继续认证后可使用完整企业功能。",
  "auth.enterXsouHint": "现在可以直接进入 Xsou。",
  "auth.continueCompanyCertification": "继续企业认证",
  "auth.skipAndEnter": "暂时跳过，先进入 Xsou",
  "auth.enterXsou": "进入 Xsou",
  "auth.agreementPrefix": "我已阅读并同意",
  "auth.userAgreement": "《用户协议》",
  "auth.agreementConjunction": "和",
  "auth.privacyPolicy": "《隐私政策》",
  "auth.emailRegistration": "邮箱注册",
  "auth.mobileRegistration": "手机号注册",
  "auth.agreementRequired":
    "登录或注册前，请先阅读并同意《用户协议》和《隐私政策》。点击确定将为您自动勾选。",
  "auth.loginAgreementRequired":
    "登录前请阅读并同意《用户协议》和《隐私政策》。确认后将自动勾选并继续登录。",
  "auth.agreementTitle": "用户协议与隐私政策",
  "auth.confirm": "确定",
  "auth.cancel": "取消",
  "auth.agreeAndLogin": "同意并登录",
  "auth.internationalSmsUnavailable": "国际短信通道待后端接口接入",
  "auth.invalidMainlandMobile": "请输入正确的中国大陆手机号",
  "auth.smsSent": "短信验证码已发送",
  "auth.internationalLoginUnavailable": "国际手机号登录接口待接入",
  "auth.invalidMobile": "请输入正确的手机号",
  "auth.invalidFourDigitCode": "请输入4位数字验证码",
  "auth.accountAndPasswordRequired": "请输入账号和密码",
  "auth.forgotPasswordUnavailable": "忘记密码流程待后端接口接入",
  "auth.qrFetchFailed": "二维码获取失败",
  "auth.wechatRegistrationSuccess": "微信注册成功",
  "auth.invalidEmail": "请输入正确的邮箱",
  "auth.emailCodeUnavailable": "邮箱验证码接口待接入",
  "auth.invalidOverseasMobile": "请输入6-20位数字手机号",
  "auth.invalidPasswordLength": "请输入 8–20 位登录密码",
  "auth.companyNameRequired": "请输入企业名称",
  "auth.contactNameRequired": "请输入联系人姓名",
  "auth.registrationExpired": "注册信息已失效，请重新注册",
  "auth.registrationWelcome": "注册成功，欢迎使用 Xsou",
  "auth.loginSuccess": "登录成功",
  "auth.requestFailed": "请求失败，请稍后重试",
});

// 移动登录
export const mobileLogin = Object.freeze({
  "mobileLogin.heroBackground": "登录页背景",
  "mobileLogin.back": "返回",
  "mobileLogin.loginHint": "登录提示",
  "mobileLogin.welcome": "欢迎登录",
  "mobileLogin.heroLineOne": "连接真实供需，",
  "mobileLogin.heroLineTwo": "让芯片交易更高效",
  "mobileLogin.accountAction": "账号操作",
  "mobileLogin.login": "登录",
  "mobileLogin.register": "注册",
  "mobileLogin.passwordLogin": "密码登录",
  "mobileLogin.smsLogin": "短信登录",
  "mobileLogin.accountPlaceholder": "请输入手机号或邮箱",
  "mobileLogin.passwordPlaceholder": "请输入登录密码",
  "mobileLogin.forgotPassword": "忘记密码",
  "mobileLogin.loggingIn": "登录中…",
  "mobileLogin.mobilePlaceholder": "请输入手机号",
  "mobileLogin.codePlaceholder": "请输入验证码",
  "mobileLogin.resendCountdown": "{seconds}s 后重发",
  "mobileLogin.getCode": "获取验证码",
  "mobileLogin.noAccount": "还没有账号？",
  "mobileLogin.registerNow": "立即注册",
  "mobileLogin.otherLoginMethods": "其他登录方式",
  "mobileLogin.wechatLogin": "微信登录",
  "mobileLogin.registerType": "注册类型",
  "mobileLogin.personalAccount": "个人账号",
  "mobileLogin.companyAccount": "企业账号",
  "mobileLogin.registerRegion": "注册地区",
  "mobileLogin.mainland": "中国大陆",
  "mobileLogin.defaultMobileRegister": "默认手机号注册",
  "mobileLogin.mobileVerification": "使用手机号验证",
  "mobileLogin.overseas": "港澳台及海外",
  "mobileLogin.defaultEmailRegister": "默认邮箱注册",
  "mobileLogin.emailVerification": "使用邮箱验证",
  "mobileLogin.mainlandMobile": "中国大陆手机号",
  "mobileLogin.overseasMobile": "港澳台及海外手机号",
  "mobileLogin.commonEmail": "常用邮箱",
  "mobileLogin.mainlandCode": "中国大陆 +86",
  "mobileLogin.hongKongCode": "中国香港 +852",
  "mobileLogin.macaoCode": "中国澳门 +853",
  "mobileLogin.taiwanCode": "中国台湾 +886",
  "mobileLogin.usCanadaCode": "美国/加拿大 +1",
  "mobileLogin.singaporeCode": "新加坡 +65",
  "mobileLogin.registrationAreaCode": "注册手机号国家或地区区号",
  "mobileLogin.areaCode": "国家或地区区号",
  "mobileLogin.emailPlaceholder": "请输入常用邮箱",
  "mobileLogin.verificationCode": "验证码",
  "mobileLogin.fourDigitCodePlaceholder": "请输入4位验证码",
  "mobileLogin.loginPassword": "登录密码",
  "mobileLogin.newPasswordPlaceholder": "请输入 8–20 位密码",
  "mobileLogin.companyName": "企业名称",
  "mobileLogin.companyNamePlaceholder": "请输入企业全称",
  "mobileLogin.contactName": "联系人姓名",
  "mobileLogin.contactNamePlaceholder": "请输入联系人姓名",
  "mobileLogin.submitting": "提交中…",
  "mobileLogin.completeRegistration": "完成注册",
  "mobileLogin.haveAccount": "已有账号？",
  "mobileLogin.loginNow": "立即登录",
  "mobileLogin.otherRegisterMethods": "其他注册方式",
  "mobileLogin.emailRegister": "邮箱注册",
  "mobileLogin.mobileRegister": "手机号注册",
  "mobileLogin.wechatRegister": "微信注册",
  "mobileLogin.readAndAgree": "我已阅读并同意",
  "mobileLogin.userAgreement": "《用户协议》",
  "mobileLogin.and": "和",
  "mobileLogin.privacyPolicy": "《隐私政策》",
  "mobileLogin.internationalSmsUnavailable": "国际短信通道待后端接口接入",
  "mobileLogin.invalidMainlandMobile": "请输入正确的中国大陆手机号",
  "mobileLogin.smsCodeSent": "短信验证码已发送",
  "mobileLogin.internationalLoginUnavailable": "国际手机号登录接口待接入",
  "mobileLogin.invalidMobile": "请输入正确的手机号",
  "mobileLogin.invalidSmsCode": "请输入正确的短信验证码",
  "mobileLogin.accountPasswordRequired": "请输入账号和密码",
  "mobileLogin.invalidEmail": "请输入正确的邮箱",
  "mobileLogin.emailCodeUnavailable": "邮箱验证码接口待接入",
  "mobileLogin.invalidOverseasMobile": "请输入6-20位数字手机号",
  "mobileLogin.invalidFourDigitCode": "请输入4位数字验证码",
  "mobileLogin.invalidPasswordLength": "请输入 8–20 位登录密码",
  "mobileLogin.companyNameRequired": "请输入企业名称",
  "mobileLogin.contactNameRequired": "请输入联系人姓名",
  "mobileLogin.registrationSucceeded": "注册成功",
  "mobileLogin.requestError": "请求异常！",
  "mobileLogin.loginSucceeded": "登录成功",
  "mobileLogin.forgotPasswordHint":
    "请先使用短信登录，登录后在个人中心修改密码",
  "mobileLogin.agreementRequired": "请先阅读并同意用户协议与隐私政策",
  "mobileLogin.agreementTitle": "用户协议与隐私政策",
  "mobileLogin.agreementMessage":
    "登录前请阅读并同意《用户协议》和《隐私政策》。确认后将自动勾选并继续登录。",
  "mobileLogin.agreeAndLogin": "同意并登录",
  "mobileLogin.cancel": "取消",
  "mobileLogin.authorizationMissing": "授权参数缺失，请重新授权",
  "mobileLogin.requestFailedRetry": "请求失败，请稍后重试",
});

// 移动实名认证
export const mobileRealname = Object.freeze({
  "realname.title": "实名认证",
  "realname.securityTitle": "信息安全保障",
  "realname.securityDescription":
    "认证信息仅用于身份核验，平台将严格保护您的隐私安全。",
  "realname.documents": "证件材料",
  "realname.idFront": "身份证人像面",
  "realname.uploadIdFront": "上传身份证人像面",
  "realname.idBack": "身份证国徽面",
  "realname.uploadIdBack": "上传身份证国徽面",
  "realname.basicInformation": "基本信息",
  "realname.matchDocumentHint": "请填写与本人证件一致的信息",
  "realname.name": "姓名",
  "realname.namePlaceholder": "请输入证件上的姓名",
  "realname.nameInvalid": "姓名不能为空、不能包含数字，且不能超过100个字符",
  "realname.idNumber": "身份证号",
  "realname.idNumberPlaceholder": "请输入18位身份证号码",
  "realname.idNumberInvalid": "请输入正确的身份证号",
  "realname.mobile": "手机号",
  "realname.mobilePlaceholder": "请输入本人手机号",
  "realname.mobileRequired": "请填写手机号码",
  "realname.smsCode": "短信验证码",
  "realname.smsCodePlaceholder": "请输入验证码",
  "realname.smsCodeRequired": "请填写短信验证码",
  "realname.useMobileAbove": "将使用上方手机号",
  "realname.wechatPlaceholder": "请输入常用微信号",
  "realname.wechat": "微信号",
  "realname.sameAsMobile": "同手机号",
  "realname.submitting": "提交中...",
  "realname.submit": "提交认证",
  "realname.getCode": "获取验证码",
  "realname.resendAfter": "{seconds}秒后重发",
  "realname.wechatRequired": "请填写微信号或选中同手机号",
  "realname.mobileInvalid": "请输入正确的手机号",
  "realname.smsSent": "短信已发送,注意查收",
  "realname.smsFailed": "发送失败，请稍后重试",
  "realname.completeRequired": "请完善必填信息",
  "realname.smsCodeInvalid": "请输入正确的短信验证码",
  "realname.success": "认证成功!",
  "realname.submitFailed": "提交失败",
  "realname.submitRetry": "提交失败，请稍后重试",
});

// 移动钱包
export const mobileWallet = Object.freeze({
  "wallet.title": "我的钱包",
  "wallet.loading": "钱包数据加载中",
  "wallet.accountAssets": "账户资产",
  "wallet.accountBalance": "账户余额",
  "wallet.goToWithdraw": "前往提现",
  "wallet.withdraw": "去提现",
  "wallet.viewDetails": "查看明细",
  "wallet.pointsDetails": "积分明细",
  "wallet.pointsDescription": "百科审核奖励及积分收支记录",
  "wallet.recordCount": "{count} 条",
  "wallet.pointsLoading": "积分明细加载中",
  "wallet.loadingShort": "加载中",
  "wallet.pointsChange": "积分变动",
  "wallet.balanceAfter": "余额 {balance}",
  "wallet.noPointsRecords": "暂无积分明细",
  "wallet.rewardDetails": "奖励明细",
  "wallet.rewardDescription": "交易成功奖励及提现进度",
  "wallet.transactionReward": "交易成功奖励",
  "wallet.identityUnknown": "未标注身份",
  "wallet.loadFailed": "钱包数据加载失败",
  "wallet.noRewardRecords": "暂无奖励明细",
  "wallet.reload": "重新加载",
  "wallet.withdrawableBalance": "可提现金额",
  "wallet.frozenBalance": "冻结金额",
  "wallet.points": "积分",
  "wallet.coins": "金币",
  "wallet.partialLoadFailed": "部分钱包数据加载失败，请稍后重试",
  "wallet.pending": "待到账",
  "wallet.received": "已到账",
  "wallet.processing": "处理中",
});

// 企业资料
export const company = Object.freeze({
  "companyInfo.companyInformation": "公司信息",
  "companyInfo.shippingInformation": "收货信息",
  "companyInfo.contacts": "联系人",
  "companyInfo.subsidiaries": "子公司管理",
  "companyInfo.addAddressAction": "+ 添加地址",
  "companyInfo.addContactAction": "+ 添加联系人",
  "companyInfo.businessLicense": "营业执照",
  "companyInfo.region": "所在地区",
  "companyInfo.mainlandChina": "大陆",
  "companyInfo.hongKongMacaoTaiwan": "港澳台",
  "companyInfo.uploadBusinessLicense": "上传营业执照",
  "companyInfo.issuingAuthority": "发证机关",
  "companyInfo.enterText": "请输入文字",
  "companyInfo.validityPeriod": "有效期",
  "companyInfo.selectStartDate": "选择开始日期",
  "companyInfo.selectEndDate": "选择结束日期",
  "companyInfo.basicInformation": "基本资料",
  "companyInfo.companyNameChinese": "公司中文名称",
  "companyInfo.companyNameEnglish": "公司英文名称",
  "companyInfo.shortName": "公司简称",
  "companyInfo.taxId": "公司税号",
  "companyInfo.supplierCode": "供应商编码",
  "companyInfo.linkedCompany": "绑定公司",
  "companyInfo.setAsParentCompany": "设为主公司",
  "companyInfo.setAsSubsidiary": "设为子公司",
  "companyInfo.personInChargeLegalRepresentative": "负责人/法人",
  "companyInfo.companyPhone": "公司电话",
  "companyInfo.companyAddress": "公司地址",
  "companyInfo.companyLogo": "企业logo",
  "companyInfo.recommendedImageSize120120Px": "建议上传 120 x 120 像素的图片",
  "companyInfo.billingInformation": "财务开票资料",
  "companyInfo.invoiceDetails": "开票资料",
  "companyInfo.uploadStampedBankAndBillingDetails":
    "上传开票资料（银行信息盖章版本）",
  "companyInfo.uploadInvoiceDetails": "上传开票资料",
  "companyInfo.bankAccounts": "银行账号管理",
  "companyInfo.bankAccount": "银行账号",
  "companyInfo.addAction": "+ 增加",
  "companyInfo.delete": "删除",
  "companyInfo.bankName": "开户银行",
  "companyInfo.bankBranch": "开户支行",
  "companyInfo.bankShortName": "银行简称",
  "companyInfo.setAsDefaultBank": "设为默认银行",
  "companyInfo.defaultBank": "默认银行",
  "companyInfo.bankRoutingNumber": "银联号",
  "companyInfo.paymentDetailsAttachment": "银行付款资料附件",
  "companyInfo.uploadAttachment": "上传附件",
  "companyInfo.additionalInformation": "补充资料",
  "companyInfo.companyType": "公司类型",
  "companyInfo.limitedLiabilityCompany": "有限责任公司",
  "companyInfo.jointStockCompany": "股份有限公司",
  "companyInfo.soleProprietorship": "个人独资企业",
  "companyInfo.partnership": "合伙企业",
  "companyInfo.productCategories": "经营品类",
  "companyInfo.productCategory1": "经营品类一",
  "companyInfo.productCategory2": "经营品类二",
  "companyInfo.brand1": "经营品牌一",
  "companyInfo.brand2": "经营品牌二",
  "companyInfo.scope1": "范围一",
  "companyInfo.scope2": "范围二",
  "companyInfo.scope3": "范围三",
  "companyInfo.category1": "品类一",
  "companyInfo.category2": "品类二",
  "companyInfo.category3": "品类三",
  "companyInfo.issuingAuthorityName": "发证机关名称",
  "companyInfo.consumerElectronics": "消费电子",
  "companyInfo.industrialControl": "工业控制",
  "companyInfo.automotiveElectronics": "汽车电子",
  "companyInfo.energyControl": "能源控制",
  "companyInfo.smartSecurity": "智能安防",
  "companyInfo.applications": "应用领域",
  "companyInfo.applicationIndustryExamples":
    "例如 消费电子、工业控制、汽车电子、LED、能源控制、智能安防、家用电器等",
  "companyInfo.brands": "经营品牌",
  "companyInfo.businessScope": "经营范围",
  "companyInfo.enterYourMainBusinessAreasThenPressEnterToAddEachOne":
    "请填写主要经营范围，点击添加输入字符，按回车确认",
  "companyInfo.add": "添加",
  "companyInfo.mainProducts": "主要产品",
  "companyInfo.enterYourMainProductsThenPressEnterToAddEachOne":
    "请填写主要产品，点击添加输入字符，按回车确认",
  "companyInfo.companyIntroduction": "公司介绍",
  "companyInfo.certificates": "资历证书",
  "companyInfo.honorsAndQualifications": "荣誉资质",
  "companyInfo.uploadOwnBrandAgencyBrandAndQualificationCertificates":
    "支持自主品牌证书、代理品牌证书、资质证书的上传",
  "companyInfo.reset": "重置",
  "companyInfo.save": "保存",
  "companyInfo.shippingAddress": "收货地址",
  "companyInfo.default": "默认",
  "companyInfo.edit": "编辑",
  "companyInfo.shippingContacts": "收货联系人",
  "companyInfo.setAsDefault": "设为默认",
  "companyInfo.chineseName": "中文名",
  "companyInfo.englishName": "英文名",
  "companyInfo.mobileNumber": "手机号码",
  "companyInfo.wechat": "微信",
  "companyInfo.landline": "座机",
  "companyInfo.more": "更多",
  "companyInfo.actions": "操作",
  "companyInfo.companyName": "公司名称",
  "companyInfo.legalRepresentative": "法人",
  "companyInfo.location": "所在地",
  "companyInfo.subsidiary": "子公司",
  "companyInfo.switch": "更换",
  "companyInfo.details": "详情",
  "companyInfo.companyDetails": "企业资料详情",
  "companyInfo.editCompanyDetails": "编辑企业资料",
  "companyInfo.file": "文件",
  "companyInfo.setAsDefaultShippingAddress": "设为默认收货地址",
  "companyInfo.uploadABusinessLicenseToRecognizeItsText":
    "上传营业执照（自动识别营业执照文字信息）",
  "companyInfo.viewAttachment": "查看附件",
  "companyInfo.paymentDetails": "付款资料",
  "companyInfo.interbankRoutingNumber": "联行号",
  "companyInfo.uploadAgain": "重新上传",
  "companyInfo.recognizeImage": "图片识别",
  "companyInfo.pasteAndRecognize": "粘贴并识别",
  "companyInfo.shippingAddressChinese": "收货地址（中）",
  "companyInfo.shippingAddressEnglish": "收货地址（英）",
  "companyInfo.recipient": "收货人",
  "companyInfo.recipientPhone": "收货电话",
  "companyInfo.contactChinese": "联系人（中）",
  "companyInfo.contactEnglish": "联系人（英）",
  "companyInfo.ms": "女士",
  "companyInfo.mr": "先生",
  "companyInfo.addButton": "+ 添加",
  "companyInfo.weChatNumber": "微信号码",
  "companyInfo.linkCompany": "+ 添加关联公司",
  "companyInfo.contactsHometown": "联系人籍贯",
  "companyInfo.personality": "联系人性格",
  "companyInfo.interests": "联系人爱好",
  "companyInfo.linkedNegotiator": "绑定谈判人",
  "companyInfo.setAsDefaultContact": "设为默认联系人",
  "companyInfo.saveContact": "提交联系人资料",
  "companyInfo.addAddress": "添加地址",
  "companyInfo.editAddress": "编辑地址",
  "companyInfo.addContact": "添加联系人",
  "companyInfo.addEditContact": "添加/编辑联系人",
  "companyInfo.enterTheCompanyNameInChinese": "请输入公司中文名称",
  "companyInfo.enterTheCompanyNameInEnglish": "请输入公司英文名称",
  "companyInfo.enterAShortCompanyName": "请输入公司简称",
  "companyInfo.enterTheTaxId": "请输入公司税号",
  "companyInfo.enterTheSupplierCode": "请输入供应商编码",
  "companyInfo.searchForACompanyToLink": "搜索需要绑定的公司名称",
  "companyInfo.enterAName": "请输入姓名",
  "companyInfo.enterTheCompanyPhone": "请输入公司电话",
  "companyInfo.enterTheCompanyAddress": "请输入公司地址",
  "companyInfo.uploadCompanyLogo": "上传企业logo",
  "companyInfo.enterTheBankName": "请输入开户银行",
  "companyInfo.enterTheBankBranch": "请输入开户支行",
  "companyInfo.enterTheBankCode": "请输入Bank Code",
  "companyInfo.enterAShortBankName": "请输入银行简称",
  "companyInfo.enterTheBankAccount": "请输入银行账号",
  "companyInfo.enterTheBankRoutingNumber": "请输入银联号",
  "companyInfo.enterTheSwiftCode": "请输入Swift Code",
  "companyInfo.select": "请选择",
  "companyInfo.enterAnApplication": "请输入应用领域名称",
  "companyInfo.uploadImage": "上传图片",
  "companyInfo.enterABrandName": "请输入品牌名称",
  "companyInfo.describeYourCompanyInUpTo500Characters":
    "请填写公司介绍，500字以内",
  "companyInfo.certificateTitle": "证书标题",
  "companyInfo.uploadFile": "上传文件",
  "companyInfo.noShippingAddresses": "暂无收货地址",
  "companyInfo.noContacts": "暂无联系人",
  "companyInfo.searchAddressRecipientOrPhone": "搜索地址、收货人、电话号码等",
  "companyInfo.noSubsidiaries": "暂无子公司",
  "companyInfo.pasteCompanyDetailsHereForAutomaticRecognitionAndFilling":
    "“粘贴识别”并输入文本，智能识别公司资料信息并填充",
  "companyInfo.enterTheShippingAddressInChinese": "请填写中文收货地址",
  "companyInfo.enterTheShippingAddressInEnglish": "请填写英文收货地址",
  "companyInfo.enterTheRecipient": "请填写收货人",
  "companyInfo.enterTheRecipientPhone": "请填写收货电话",
  "companyInfo.enterTheContactNameInChinese": "请填写联系人中文名称",
  "companyInfo.enterTheContactNameInEnglish": "请填写联系人英文名称",
  "companyInfo.enterAMobileNumber": "请填写手机号码",
  "companyInfo.enterAWechatId": "请填写微信号码",
  "companyInfo.enterALandlineNumber": "请填写座机",
  "companyInfo.enterTheLinkedCompany": "请填写绑定公司",
  "companyInfo.enterTheContactsHometown": "请填写联系人籍贯",
  "companyInfo.searchANegotiatorByPhone": "搜索需要绑定的谈判人电话号码",
  "companyInfo.bankPaymentDetailsUploaded": "银行付款资料上传成功",
  "companyInfo.savedSuccessfully": "保存成功",
  "companyInfo.couldNotSave": "保存失败",
  "companyInfo.defaultContactUpdated": "默认联系人设置成功",
  "companyInfo.deleteThisContact": "确认删除该联系人?",
  "companyInfo.deleteThisAddress": "确认删除该地址?",
  "companyInfo.deleteThisCompany": "确认删除该公司?",
  "companyInfo.deleteThisBankAccount": "确认删除该银行账户?",
  "companyInfo.confirm": "提示",
  "companyInfo.deletedSuccessfully": "删除成功",
  "companyInfo.youCanAddMoreMobileNumbers": "可在手机号中继续补充多个号码",
  "companyInfo.youCanAddMoreWechatIds": "可在微信号码中继续补充多个微信",
  "companyInfo.linkACompany": "添加关联公司",
  "companyInfo.cannotSaveContactCompanyIdIsMissing":
    "缺少企业ID，无法保存联系人",
  "companyInfo.defaultShippingAddressUpdated": "默认收货地址设置成功",
  "companyInfo.selectAnImageFile": "请选择图片文件",
  "companyInfo.selectAnImageOrEnterTextFirst": "请先选择图片或输入文本",
  "companyInfo.informationRecognized": "识别成功",
  "companyInfo.recognitionFailed": "识别失败",
  "companyInfo.recognitionFailedPleaseTryAgain": "识别失败，请重试",
  "companyInfo.cannotSaveAddressCompanyIdIsMissing": "缺少企业ID，无法保存地址",
  "companyInfo.batchManagement": "批量管理",
  "companyInfo.newCompany": "新建公司",
  "companyInfo.switchLinkedCompany": "切换绑定公司",
  "companyInfo.editBankAccount": "编辑银行账户",
  "companyInfo.addBankAccount": "添加银行账户",
});

// 个人中心菜单
export const menu = Object.freeze({
  "personalMenu.outboundManagement": "出货管理",
  "personalMenu.contractTranslation": "合同译文审核",
  "personalMenu.contentTranslation": "动态译文管理",
  "personalMenu.featuredTrading": "精选交易",
  "personalMenu.wallet": "我的钱包",
  "personalMenu.reportDashboard": "数据看板",
  "personalMenu.orders": "交易订单",
  "personalMenu.goodsCenter": "商品中心",
  "personalMenu.goodsLibrary": "商品库",
  "personalMenu.brands": "品牌管理",
  "personalMenu.suppliers": "供应商管理",
  "personalMenu.messages": "消息管理",
  "personalMenu.supplyDemand": "供应需求",
  "personalMenu.postSupply": "供应发布",
  "personalMenu.postDemand": "需求发布",
  "personalMenu.quickSupply": "简洁供应发布",
  "personalMenu.quickDemand": "简洁需求发布",
  "personalMenu.bulkPost": "批量发布",
  "personalMenu.customerManagement": "客户管理",
  "personalMenu.myCustomers": "我的客户",
  "personalMenu.myOrders": "我的订单",
  "personalMenu.memberLevel": "会员等级",
  "personalMenu.levelList": "等级列表",
  "personalMenu.levelApplication": "等级申请",
  "personalMenu.levelBenefits": "等级权益",
  "personalMenu.memberIdentity": "会员身份",
  "personalMenu.identityList": "身份列表",
  "personalMenu.salesperson": "业务员",
  "personalMenu.customer": "客户",
  "personalMenu.supplier": "供应商",
  "personalMenu.partner": "合作伙伴",
  "personalMenu.bidManagement": "竞标管理",
  "personalMenu.bidReview": "竞标审核",
  "personalMenu.bidList": "竞标列表",
  "personalMenu.postBid": "发布竞标",
  "personalMenu.myBids": "我的竞标",
  "personalMenu.myFollowers": "我的跟单员",
  "personalMenu.myFollowUps": "我的跟单",
  "personalMenu.favorites": "我的收藏",
  "personalMenu.wiki": "知识百科",
  "personalMenu.reviewManagement": "审核管理",
  "personalMenu.myPosts": "我的发布",
  "personalMenu.myQuestions": "我的问答",
  "personalMenu.specifications": "规格书管理",
  "personalMenu.accountSettings": "账号设置",
  "personalMenu.personalInfo": "个人资料",
  "personalMenu.companyInfo": "企业资料",
  "personalMenu.security": "安全设置",
  "personalMenu.verification": "账号认证",
  "personalMenu.priceChannel": "价格频道",
  "personalMenu.channelIdentity": "频道身份",
  "personalMenu.messageCenter": "消息中心",
  "personalMenu.watchlists": "行情自选",
  "personalMenu.certification": "企业认证",
  "personalMenu.submissions": "业务上报",
  "personalMenu.reviewQueue": "审核待办",
  "personalMenu.reviewResults": "审查结果",
  "personalMenu.loading": "加载中...",
  "personalMenu.loadFailed": "加载失败，请重试",
  "personalMenu.loginFirst": "请先登录",
});

// 桌面实名认证
export const desktopRealname = Object.freeze({
  "pcRealname.title": "实名认证",
  "pcRealname.back": "返回",
  "pcRealname.personalVerification": "个人认证",
  "pcRealname.submitIdentity": "提交身份认证信息",
  "pcRealname.identityInstructions":
    "请上传本人有效身份证件，并确保填写信息与证件一致。",
  "pcRealname.pending": "待认证",
  "pcRealname.documentMaterials": "证件材料",
  "pcRealname.fileRequirements": "支持 JPG、PNG 格式，单张图片不超过 5MB",
  "pcRealname.bothSidesRequired": "两面均需上传",
  "pcRealname.portraitSide": "身份证人像面",
  "pcRealname.portraitDescription": "包含姓名、身份证号码的一面",
  "pcRealname.uploadPortrait": "上传人像面",
  "pcRealname.emblemSide": "身份证国徽面",
  "pcRealname.emblemDescription": "包含签发机关、有效期限的一面",
  "pcRealname.uploadEmblem": "上传国徽面",
  "pcRealname.basicInfo": "基本信息",
  "pcRealname.requiredHint": "带 * 的字段为必填项，请核对无误后提交",
  "pcRealname.fullName": "姓名",
  "pcRealname.namePlaceholder": "请输入证件上的姓名",
  "pcRealname.idNumber": "身份证号",
  "pcRealname.idPlaceholder": "请输入18位身份证号码",
  "pcRealname.mobile": "手机号",
  "pcRealname.mobilePlaceholder": "请输入本人手机号",
  "pcRealname.smsCode": "短信验证码",
  "pcRealname.smsPlaceholder": "请输入验证码",
  "pcRealname.getCode": "获取验证码",
  "pcRealname.resendIn": "{count}秒后重新发送",
  "pcRealname.wechatId": "微信号",
  "pcRealname.wechatPlaceholder": "请输入常用微信号",
  "pcRealname.sameMobile": "同手机号",
  "pcRealname.invalidName": "姓名不能为空、不能包含数字，且不能超过100个字符",
  "pcRealname.invalidId": "请输入正确的身份证号",
  "pcRealname.mobileRequired": "请填写手机号码",
  "pcRealname.smsRequired": "请填写短信验证码",
  "pcRealname.privacyNotice":
    "认证信息仅用于身份核验，平台将严格保护您的信息安全",
  "pcRealname.cancel": "取消",
  "pcRealname.submit": "提交认证",
  "pcRealname.process": "认证流程",
  "pcRealname.estimatedTime": "预计 1–2 分钟",
  "pcRealname.uploadDocuments": "上传证件",
  "pcRealname.uploadDocumentsHint": "提交身份证人像面与国徽面",
  "pcRealname.completeInformation": "填写信息",
  "pcRealname.completeInformationHint": "补充本人身份及联系方式",
  "pcRealname.finishVerification": "完成核验",
  "pcRealname.finishVerificationHint": "提交后完成实名认证",
  "pcRealname.photoRequirements": "拍摄要求",
  "pcRealname.photoCorners": "证件四角完整，不要裁切或遮挡",
  "pcRealname.photoClarity": "文字清晰可辨，避免反光与阴影",
  "pcRealname.photoValidity": "请上传本人且在有效期内的证件",
  "pcRealname.invalidMobile": "请输入正确的手机号",
  "pcRealname.smsSent": "短信已发送,注意查收",
  "pcRealname.smsSendFailed": "发送失败，请稍后重试",
  "pcRealname.completeRequired": "请完善必填信息",
  "pcRealname.wechatOrMobileRequired": "请填写微信号或选中同手机号",
  "pcRealname.invalidSms": "请输入正确的短信验证码",
  "pcRealname.success": "认证成功!",
  "pcRealname.submitFailed": "提交失败",
});

// 桌面钱包
export const desktopWallet = Object.freeze({
  "pcWallet.title": "我的钱包",
  "pcWallet.subtitle": "查看账户资产与交易奖励记录",
  "pcWallet.overview": "账户概览",
  "pcWallet.overviewHint": "账户资金与权益资产",
  "pcWallet.balance": "账户余额",
  "pcWallet.assets": "账户资产",
  "pcWallet.totalBalance": "当前账户总余额",
  "pcWallet.withdraw": "去提现",
  "pcWallet.withdrawable": "可提现金额",
  "pcWallet.withdrawableHint": "可申请提现",
  "pcWallet.frozen": "冻结金额",
  "pcWallet.frozenHint": "待结算资金",
  "pcWallet.points": "积分",
  "pcWallet.pointsHint": "点击查看积分明细",
  "pcWallet.coins": "金币",
  "pcWallet.benefits": "账户权益",
  "pcWallet.pointsLedger": "积分明细",
  "pcWallet.pointsLedgerHint": "查看百科审核奖励及积分收支记录",
  "pcWallet.noPoints": "暂无积分明细",
  "pcWallet.changeDescription": "变动说明",
  "pcWallet.pointsChange": "积分变动",
  "pcWallet.pointsBalance": "积分余额",
  "pcWallet.changedAt": "变动时间",
  "pcWallet.rewards": "奖励明细",
  "pcWallet.rewardsHint": "交易成功奖励及提现进度",
  "pcWallet.name": "名称",
  "pcWallet.tradeReward": "交易成功奖励",
  "pcWallet.tradeIdentity": "交易身份",
  "pcWallet.amount": "金额",
  "pcWallet.withdrawalProgress": "提现进度",
  "pcWallet.pending": "待到账",
  "pcWallet.received": "已到账",
});

// 手机端业务流程：固定界面文案。
export const mobileWorkflow = Object.freeze({
  "evaluation.result": "本次交易评价结果",
  "evaluation.instructions": "请按实际体验完成评价，提交后不可修改",
  "evaluation.awaitingRating": "待评分",
  "evaluation.rateTarget": "对{target}的综合评价",
  "supplier.fileCount": "共 {count} 份",
  "profile.myServices": "我的服务",
  "profile.myReviews": "我的评价",
  "profile.inProgress": "进行中",
  "profile.frequentFirst": "高频词1",
  "profile.frequentSecond": "高频词2",
  "account.confirmLogout": "确认退出当前账号吗？",
  "evaluation.requestFailed": "请求失败",
  "evaluation.succeeded": "评价成功",
  "evaluation.failed": "评价失败",
  "supplier.taxNumber": "供应商税号",
  "evaluation.description": "评价说明",
  "evaluation.overall": "综合评价",
  "evaluation.negative": "差评",
  "evaluation.neutral": "中评",
  "evaluation.positive": "好评",
  "evaluation.categoryRatings": "分项评分",
  "evaluation.attitude": "服务态度",
  "evaluation.attitudeScore": "服务态度评分",
  "evaluation.service": "服务内容",
  "evaluation.serviceScore": "服务内容评分",
  "evaluation.response": "响应速度",
  "evaluation.responseScore": "响应速度评分",
  "evaluation.noRecipients": "暂无可评价的服务对象",
  "evaluation.submit": "提交评价",
  "evaluation.recipientCount": "位评价对象",
  "profile.sampleYears": "入驻x年",
  "profile.companyPlaceholder": "｜公司名称",
  "profile.overallScore": "综合分",
  "profile.sampleOrders": "26单",
  "profile.completedDeals": "已成交",
  "profile.positiveScore": "好评分",
});

// PC界面显示文案；不改动业务原值。
export const desktopWalletFollowup = Object.freeze({
  "pcWallet.noWithdrawals": "暂无提现明细",
  "pcWallet.totalCredit": "总额度：{amount}",
});

export const companyDialogs = Object.freeze({
  "companyDialogs.setDefaultBankFailed": "设置默认银行失败",
  "companyDialogs.addressIntro": "录入或选择买方收货地址，用于采购订单收货信息",
  "companyDialogs.recipientNameRequired": "请填写收货人姓名",
  "companyDialogs.noAddresses": "暂无地址可更换",
  "companyDialogs.dropImage": "请拖入图片文件",
  "companyDialogs.bankShortNameRequired": "请填写银行简称",
  "companyDialogs.accountInformation": "账户信息",
  "companyDialogs.accountNameRequired": "请填写账户名称",
  "companyDialogs.accountAndCodes": "账号与银行代码",
  "companyDialogs.defaultBankHint": "选择银行后将同步设为默认银行",
  "companyDialogs.switchBankHint": "更换当前开户银行，确认后同步银行信息",
  "companyDialogs.noBanks": "暂无银行",
  "companyDialogs.accountPrefix": "账号：",
  "companyDialogs.switchBank": "更换银行",
  "companyDialogs.noAlternativeBanks": "暂无可更换的银行",
  "companyDialogs.confirmBankSwitch": "确认更换",
  "companyDialogs.companyNameZh": "公司名称（中）",
  "companyDialogs.companyNameEn": "公司名称（英）",
  "companyDialogs.bankNameZh": "银行名称（中）",
  "companyDialogs.bankNameEn": "银行名称（英）",
  "companyDialogs.companySearchFailed": "公司查询失败，请重试",
  "companyDialogs.companySearchPlaceholder": "输入公司名称查询",
  "companyDialogs.companyCreateFailed": "新建公司失败",
  "companyDialogs.bankSwitched": "银行信息已更换",
  "companyDialogs.createdBankRefresh":
    "银行已创建，但未能识别新银行，请刷新公司资料后重新选择",
  "companyDialogs.confirmDeleteSupplier":
    "确认删除“{name}”吗？删除后不可恢复。",
  "companyDialogs.contactCreated": "新建联系人成功",
  "companyDialogs.contactChanged": "更换联系人成功",
  "companyDialogs.defaultBankSet": "默认银行设置成功",
  "companyDialogs.bankConfirmed": "银行信息已确认",
  "companyDialogs.addressCreated": "新增地址成功",
  "companyDialogs.addressChanged": "更换地址成功",
  "companyDialogs.confirmChangeAddress": "确认更换",
  "companyDialogs.newMainlandBank": "新建大陆银行",
  "companyDialogs.newHongKongBank": "新建香港银行",
  "companyDialogs.mainlandBankIntro": "补充大陆银行账户信息，用于采购订单结算",
  "companyDialogs.hongKongBankIntro": "补充香港银行账户信息，用于采购订单结算",
  "companyDialogs.bankEntityMissing": "当前银行缺少实体ID，无法设为默认银行",
  "companyDialogs.unnamedBank": "未命名银行",
});

export const sharedFlowUi = Object.freeze({
  "companyDialogs.parentCompanyRequired": "设为子公司时必须绑定父公司",
  "companyDialogs.yearFiles": "{year} 年（{count}）",
  "companyDialogs.yearOption": "{year}年",
  "companyDialogs.monthOption": "{month}月",
  "companyDialogs.dayOption": "{day}日",
  "googleFeedback.unavailableLabel": "{label}不可用：{error}",
  "googleFeedback.configurationUnavailable": "Google 登录配置暂不可用",
  "googleFeedback.initializationFailed": "Google 登录初始化失败",
  "googleFeedback.unavailableRetry": "Google 登录暂不可用，请重试",
  "googleFeedback.verifyAccount": "请验证已有平台账号",
  "googleFeedback.reconnect": "Google 登录失败，请重新连接",
});

// 钱包接口返回的固定来源与系统流水描述；不改写历史账本。
export const walletLedger = Object.freeze({
  "walletLedger.firstDatasheetDownload": "首次下载规格书",
  "walletLedger.repeatDatasheetDownload": "重复下载规格书",
  "walletLedger.datasheetDownload": "下载规格书",
  "walletLedger.datasheetDownloadCharge": "规格书下载扣除积分",
  "walletLedger.wikiReviewReward": "百科审核奖励",
  "walletLedger.wikiReviewApprovedReward": "百科审核通过奖励",
  "walletLedger.wikiPublishReward": "百科发布奖励",
  "walletLedger.wikiContentPublished": "百科内容审核通过并发布",
  "walletLedger.wikiFavoriteReward": "百科收藏奖励",
  "walletLedger.pointsTopUp": "积分充值",
  "walletLedger.pointsRefund": "积分退还",
  "walletLedger.pointsAdjustment": "积分调整",
  "walletLedger.adminAdjustment": "管理员调整积分",
  "walletLedger.systemGift": "系统赠送",
  "walletLedger.withdrawDebit": "提现发起扣减用户正常余额",
  "walletLedger.withdrawTotalIncrease": "提现发起新增累计提现金额",
  "walletLedger.withdrawRefund": "提现驳回退回用户正常余额",
  "walletLedger.withdrawTotalDecrease": "提现驳回减少累计提现金额",
  "walletLedger.creditRepayment": "信用额度还款",
  "walletLedger.balanceCreditRepayment": "余额用于信用额度还款",
  "walletLedger.sellerReferrer": "卖方信息提供人",
  "walletLedger.sellerNegotiator": "卖方谈判人",
  "walletLedger.sellerBusiness": "卖方商务",
  "walletLedger.buyerReferrer": "买方信息提供人",
  "walletLedger.buyerNegotiator": "买方谈判人",
  "walletLedger.buyerBusiness": "买方商务",
  "walletLedger.supervisor": "监督人",
  "walletLedger.inspector": "验货人",
  "walletLedger.noBalanceRecords": "暂无余额明细",
  "walletLedger.withDetail": "{reason}：{detail}",
  "walletLedger.creditUpgrade": "信用等级提升：L{before} -> L{after}",
});

export const messages = Object.freeze({
  ...walletLedger,
  ...sharedFlowUi,
  ...companyDialogs,
  ...desktopWalletFollowup,
  ...mobileWorkflow,
  ...base,
  ...settings,
  ...auth,
  ...mobileLogin,
  ...mobileRealname,
  ...mobileWallet,
  ...company,
  ...menu,
  ...desktopRealname,
  ...desktopWallet,
});
